(() => {
  const SELECTORS = {
    widget: "[data-custom-subscription-box]",
    forms: 'form[action^="/cart/add"]',
    sellingPlansJson: "[data-csb-selling-plans]",
    recharge:
      ".rc-container-wrapper, .rc_container_wrapper, .recharge-subscription-widget, .rc-widget, .rc_widget",
    quantityInputsPdp:
      '.product-form__quantity quantity-input input.quantity__input[name="quantity"]',
    quantityInputsForms: 'form[action^="/cart/add"] input[name="quantity"]',
    variantsJson: "[data-csb-variants]",
  };

  function getAddToCartForms() {
    return Array.from(document.querySelectorAll(SELECTORS.forms));
  }

  function ensureHiddenInput(form, name) {
    if (!form) return null;
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  function setHiddenFieldOnForms(name, value) {
    const v = value || "";
    getAddToCartForms().forEach((form) => {
      const input = ensureHiddenInput(form, name);
      if (input) input.value = v;
    });
  }

  function getCheckedValue(root, name, fallback) {
    const el = root.querySelector(`input[name="${name}"]:checked`);
    return el?.dataset?.csbPurchase || el?.value || fallback;
  }

  function getSelectedPurchase(widget) {
    return getCheckedValue(widget, "csb_purchase", "one");
  }

  function getSelectedQty(widget) {
    const raw = getCheckedValue(widget, "csb_schedule", "1");
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function setQuantity(qty) {
    const value = String(qty);

    const apply = (input) => {
      input.value = value;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    };

    document.querySelectorAll(SELECTORS.quantityInputsPdp).forEach(apply);
    document.querySelectorAll(SELECTORS.quantityInputsForms).forEach(apply);
  }

  function readSellingPlansJson() {
    const el = document.querySelector(SELECTORS.sellingPlansJson);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function readVariantsJson() {
    const el = document.querySelector(SELECTORS.variantsJson);
    if (!el) return [];
    try {
      const v = JSON.parse(el.textContent);
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  }

  function setVariantIdOnForms(variantId) {
    const v = String(variantId || "");
    if (!v) return;

    getAddToCartForms().forEach((form) => {
      let input = form.querySelector('input[name="id"]');
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "id";
        form.appendChild(input);
      }
      input.value = v;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function getSelectedServing(widget) {
    const el = widget.querySelector('input[name="csb_formula"]:checked');
    return el?.value || "";
  }

  function pickVariantIdByServing(variants, servingValue) {
    const want = String(servingValue || "").trim().toLowerCase();
    if (!want) return "";

    const match = variants.find((v) => {
      const opt1 = String(v?.option1 || "").trim().toLowerCase();
      return opt1 === want && v?.available !== false;
    });

    const any = variants.find((v) => {
      const opt1 = String(v?.option1 || "").trim().toLowerCase();
      return opt1 === want;
    });

    return String((match || any)?.id || "");
  }

  function pickSubscriptionSellingPlanId(groups) {
    if (!Array.isArray(groups) || groups.length === 0) return "";

    const POS = [
      "subscription",
      "subscribe",
      "subsave",
      "discount",
      "monthly",
      "recurring",
      "every",
      "%",
    ];
    const NEG = [
      "preorder",
      "pre-order",
      "upfront",
      "full upfront",
      "full payment",
      "deposit",
      "begins shipping",
      "shipping",
      "ships",
      "december",
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
    ];

    const scoreText = (str) => {
      const s = String(str || "").toLowerCase();
      let score = 0;
      for (const p of POS) if (s.includes(p)) score += 2;
      for (const n of NEG) if (s.includes(n)) score -= 6;
      return score;
    };

    const candidates = [];

    for (const g of groups) {
      const groupName = g?.name || "";
      const plans = Array.isArray(g?.selling_plans) ? g.selling_plans : [];
      for (const p of plans) {
        if (!p?.id) continue;
        const planName = p?.name || "";
        const score = scoreText(planName) + scoreText(groupName);
        candidates.push({ id: String(p.id), score });
      }
    }

    if (!candidates.length) return "";

    candidates.sort((a, b) => b.score - a.score);
    const best = candidates[0];
    return best && best.score >= 1 ? best.id : "";
  }

  function hideRechargeUI() {
    document.querySelectorAll(SELECTORS.recharge).forEach((el) => {
      el.style.setProperty("display", "none", "important");
      el.setAttribute("aria-hidden", "true");
    });
  }

  function formatMoney(cents) {
    return (
      "$" +
      (cents / 100).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    );
  }

  // update ATC button price
  function updateAtcPrice(widget) {
    const priceEl = document.querySelector("[data-csb-price]");
    if (!priceEl) return;

    const basePrice = parseInt(priceEl.dataset.csbBasePrice || "0", 10);
    if (!basePrice) return;

    const compareEl = document.querySelector("[data-csb-price-compare]");
    const promoPercent = parseInt(priceEl.dataset.csbPromoPercent || "0", 10);

    const purchase = getSelectedPurchase(widget);
    const qty = getSelectedQty(widget);

    let price = basePrice;
    let showCompare = false;

    if (purchase === "sub") {
      // Subscription keeps its own discount and is excluded from the promo
      price = Math.round(basePrice * 0.8);
    } else if (promoPercent > 0) {
      price = Math.round((basePrice * (100 - promoPercent)) / 100);
      showCompare = true;
    }

    priceEl.textContent = formatMoney(price * qty);

    if (compareEl) {
      compareEl.textContent = showCompare ? formatMoney(basePrice * qty) : "";
      compareEl.style.display = showCompare ? "" : "none";
    }
  }

  function initWidget(widget) {
    document.body.classList.add("csb-active");

    const accent = getComputedStyle(widget).getPropertyValue("--csb-accent").trim();
    if (accent) {
      document.body.style.setProperty("--csb-accent", accent);
    }

    const mainAtcBtn = document.querySelector('button.product-form__submit[type="submit"]');
    if (mainAtcBtn) mainAtcBtn.classList.add("csb-main-atc");
    hideRechargeUI();

    const groups = readSellingPlansJson();
    const subscriptionPlanId = pickSubscriptionSellingPlanId(groups);

    const variants = readVariantsJson();

    const applyVariantFromServing = () => {
      const serving = getSelectedServing(widget);
      if (!serving) return;

      const vid = pickVariantIdByServing(variants, serving);
      if (vid) setVariantIdOnForms(vid);
    };

    const applySellingPlan = () => {
      const purchase = getSelectedPurchase(widget);
      if (purchase === "sub" && subscriptionPlanId) {
        setHiddenFieldOnForms("selling_plan", subscriptionPlanId);
      } else {
        setHiddenFieldOnForms("selling_plan", "");
      }
    };

    const updateSaveBadgesVisibility = () => {
      const purchase = getSelectedPurchase(widget);

      const saves = widget.querySelectorAll(".csb-save");
      saves.forEach((el) => {
        el.style.display = purchase === "one" ? "none" : "";
      });

      const benefits = widget.querySelector("[data-csb-benefits]");
      if (benefits) {
        benefits.style.display = purchase === "one" ? "none" : "";
      }
    };

    const applyQty = () => {
      setQuantity(getSelectedQty(widget));
    };

    const applyAll = () => {
      applyVariantFromServing();
      applyQty();
      applySellingPlan();
      updateSaveBadgesVisibility();
      updateAtcPrice(widget);
    };

    applyAll();

    widget.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;

      if (t.name === "csb_formula") {
        applyVariantFromServing();
      }

      if (t.name === "csb_purchase") {
        applySellingPlan();
        updateSaveBadgesVisibility();
      }

      if (t.name === "csb_schedule") {
        applyQty();
      }

      updateAtcPrice(widget);
    });

    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target;
        if (form && form.matches(SELECTORS.forms)) applyAll();
      },
      true
    );
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(SELECTORS.widget).forEach(initWidget);
  });
})();